// 存储localStorage
export const setStore = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  try {
    window.localStorage.setItem(name, content)
  } catch (e) {
    console.log(e)
    return false
  }
}

// 获取localStorage
export const getStore = (name, isParse = false) => {
  if (!name) return
  try {
    let val = window.localStorage.getItem(name)
    isParse && val && (val = JSON.parse(val))
    return val
  } catch (e) {
    return false
  }
}

// 删除localStorage
export const removeStore = name => {
  if (!name) return
  window.localStorage.removeItem(name)
}

// js判断是否存在class
export function hasClass (obj, cls) {
  if (obj.className) {
    return obj.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
  }
  return false
}

// js 注册事件
export function addEvent (elem, type, listener, useCapture) {
  if (document.addEventListener) {
    elem.addEventListener(type, listener, useCapture)
  } else {
    elem.attachEvent('on' + type, listener)
  }
}

// 增加类
export function addClass (node, className) {
  let current = node.className || ''
  if ((' ' + current + ' ').indexOf(' ' + className + ' ') === -1) {
    node.className = current ? (current + ' ' + className) : className
  }
}
// 减少类
export function delClass (node, className) {
  let current = node.className || ''
  node.className = (' ' + current + ' ').replace(' ' + className + ' ', ' ').trim()
}

// 选择器
export function _sel (selector) {
  return [].slice.call(document.querySelectorAll(selector))
};

// 日期格式化
export function formatDate (date, fmt) { // author: meizz
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

export function isIE () {
  if (!!window.ActiveXObject || 'ActiveXObject' in window) { return true } else { return false }
}

export const getItem = (list, val) => {
  const item = list.find((_) => _.value === val) || {};
  return item.label;
}
